"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconWeatherWind = function IconWeatherWind(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '24px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M9.003 4.232a2.97 2.97 0 0 0-2.315.008 2.8 2.8 0 0 0-.966.654c-.256.246-.48.567-.637.922A3 3 0 0 0 5.08 8.17c.155.36.374.68.648.95.263.273.599.499.97.648.351.15.749.231 1.151.232H19V8H7.85l-.132-.01a1 1 0 0 1-.256-.07 1.035 1.035 0 0 1-.544-.536 1 1 0 0 1 .003-.774 1 1 0 0 1 .214-.3A1.033 1.033 0 0 1 7.857 6a1 1 0 0 1 .381.08c.13.053.23.12.314.206l1.436-1.392-.173-.165a2.9 2.9 0 0 0-.812-.497M22 14H6v-1l-.007 1a1.9 1.9 0 0 0-.772.16 2 2 0 0 0-1.06 2.62 2 2 0 0 0 3.11.762l.142-.13 1.414 1.415a4 4 0 0 1-6.508-1.267 4 4 0 0 1 3.456-5.555L6 12h16z",
    clipRule: "evenodd"
  })));
};

export { IconWeatherWind, IconWeatherWind as default };
